export { DMS_MODULE } from '../constants';
export const NAME = 'StockValueMovement';
export const API_NAME = 'StockValueMovement';
export const EXPORT_FILE_NAME = 'StockValueMovementReport.xlsx';
export const CRUMB_LABEL_KEY = 'StockValueMovement';

export type SestavaButton = { labelKey: string, routeName: string, api: string, permission: number };
